export default __webpack_public_path__ + "static/media/017-erlemeyer flask.74b52e49.svg";